import { getCookieDomain } from '@/utils/cookie'
import { FETCH_USER } from '@/utils/store/actionTypes'

export default async function ({ store: { dispatch, state: { app: appState } }, route, app, redirect }) {
  const loginToken = route.query.utkn

  if (!loginToken) {
    return
  }

  await app.$auth.setUserToken(loginToken)
  await app.$apolloHelpers.onLogin(loginToken)
  app.$cookies.set('apollo-expires', app.$moment(new Date()).add(1, 'hour').unix())

  try {
    const response = await dispatch(`auth/${FETCH_USER}`)

    const country = response.user.country.name.toLowerCase()
    const i18Params = `/${appState.locale}-${country}`

    return redirect(`${i18Params}/account`)
  } catch (error) {
    app.$cookies.remove('apollo-token', {
      path: '/',
      domain: getCookieDomain()
    })

    app.$cookies.remove('apollo-expires', {
      path: '/',
      domain: getCookieDomain()
    })
  }
}
